package meineglasfaser.frontend.www.pages.portal

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.navigation.Anchor
import meineglasfaser.api.routes.CustomerPortalRoutes
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.components.widgets.*
import meineglasfaser.frontend.common.components.yaform.YaForm
import meineglasfaser.frontend.common.components.yaform.YaFormButton
import meineglasfaser.frontend.common.withAuth
import meineglasfaser.frontend.www.components.LocalCustomerState
import meineglasfaser.frontend.www.components.widgets.ServicePinDisplay
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.dom.*

@Page
@Layout(".components.layouts.PortalLayout")
@Composable
fun OverviewPage() {
    val baseInfo = LocalCustomerState.current.accountInfoOrNull() ?: return

    if (!baseInfo.accountEmailVerified) {
        EmailVerificationWarning()
    }

    Div({ classes("row-fluid") }) {
        Div({ classes("col-12", "col-md-6") }) {
            Article {
                Header {
                    Text("Meine Kundennummer")
                }
                Text(baseInfo.nid.toString())
            }
        }
        Div({ classes("col-12", "col-md-6") }) {
            Article {
                Header {
                    Text("Meine Service-PIN")
                }
                ServicePinDisplay(baseInfo.accountServicePIN)
            }
        }
    }
}

@Composable
fun EmailVerificationWarning() {
    Article({ classes("bg-warn") }) {
        Header {
            BootstrapIcon("exclamation-triangle-fill")
            Text(" E-Mail nicht verifiziert")
        }
        Section {
            Text("Bitte verifizieren Sie Ihre E-Mail-Adresse, um alle Funktionen nutzen zu können.")
        }
        Section {
            Details({ attr("name", "wrong-email") }) {
                Summary {
                    Text("Keine E-Mail erhalten?")
                }
                YaForm(
                    onSubmitScope = {
                        BackendApi.post(CustomerPortalRoutes.Account.RequestNewVerificationMail()) {
                            withAuth()
                        }.fold(
                            onSuccess = {
                                Toasts.display(
                                    Toast.success("Verifizierungs-E-Mail wurde erneut versendet.")
                                )
                            },
                            onFailure = { error ->
                                Toasts.display(
                                    Toast.error("Fehler beim Anfordern der Verifizierungs-E-Mail: ${error.message}")
                                )
                            }
                        )
                    }
                ) {
                    Text("Bitte überprüfen Sie auch Ihren Spam-Ordner. Falls Sie keine E-Mail finden, können Sie eine neue Verifizierungs-E-Mail anfordern, indem Sie auf den folgenden Button klicken.")
                    YaFormButton(type = ButtonType.Submit) {
                        Text("Neue Verifizierungs-E-Mail anfordern")
                    }
                }
            }
        }
        Section {
            Details({ attr("name", "wrong-email") }) {
                Summary {
                    Text("Falsche E-Mail angegeben?")
                }
                P {
                    Text("Sie können Ihre E-Mail-Adresse ganz einfach in Ihren Account-Einstellungen ändern.")
                }
                Anchor(href = "/kundenportal/my-account") {
                    Text("Zu den Account-Einstellungen")
                }
            }
        }
    }
}
